var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"m368 154.667969h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0","key":0}),React.createElement("path",{"fill":"currentColor","d":"m368 32h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0","key":1}),React.createElement("path",{"fill":"currentColor","d":"m368 277.332031h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0","key":2})]);
}

Menu.defaultProps = {"viewBox":"0 -53 384 384"};

module.exports = Menu;

Menu.default = Menu;
